import {prepareOperationsRequestParams} from 'shared/helpers/operations';
import {OperationParams} from 'shared/models/task/filter';
import {OperationModelRawDTO} from 'shared/models/task/task';

import {ApiAxios} from './axiosClient';

type CreateOperationParams = (Partial<OperationModelRawDTO> & {name: string})[];

class OperationsService {
  private static instance: OperationsService | null = null;

  public static getInstance(): OperationsService {
    if (!OperationsService.instance) {
      OperationsService.instance = new OperationsService();
    }
    return OperationsService.instance;
  }

  private getOperationsBasePath(projectId: string) {
    return `/projects/${projectId}/operations`;
  }

  async getOperation(projectId: string, operationId: string) {
    const res = await ApiAxios.get(`${this.getOperationsBasePath(projectId)}/${operationId}`);
    return res.data;
  }

  async getOperations(projectId: string, operationsParams: OperationParams = {}) {
    const params = prepareOperationsRequestParams(operationsParams);
    const res = await ApiAxios.get(this.getOperationsBasePath(projectId), {
      ...params,
      disableCamelCaseConverter: true,
      cancelToken: operationsParams.cancelToken,
    });
    return res.data;
  }

  async createOperation(projectId: string, payload: CreateOperationParams) {
    const res = await ApiAxios.post<OperationModelRawDTO[]>(this.getOperationsBasePath(projectId), payload, {
      disableCamelCaseConverter: true,
    });
    return res.data;
  }

  async updateOperation(operationId: string, projectId: string, payload: Partial<OperationModelRawDTO>) {
    const res = await ApiAxios.post<OperationModelRawDTO>(
      `${this.getOperationsBasePath(projectId)}/${operationId}`,
      payload,
    );
    return res.data;
  }

  async deleteOperation(projectId: string, operationId: string) {
    const res = await ApiAxios.delete<OperationModelRawDTO>(`${this.getOperationsBasePath(projectId)}/${operationId}`);
    return res.data;
  }
}

export const operationsService = OperationsService.getInstance();
